function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#000;stroke-miterlimit:10;}.b{stroke-width:4.97px;}.c{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-870.819 -701.954)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M889.558,742.436c1.224-10.608,4.7-21.8,10.418-25.341,8.735-5.4,24.214.563,32.1,10.418a54.558,54.558,0,0,1,7.6,15.2c2.252-5.35,3.883-8.118,5.842-8.485,8.174-1.53,7.8,15.86,2.323,18.9-2.534,1.408-5.913,0-7.884-1.126-9.01,8.165-20.939,9.26-31.067,8.555-6.539-.455-19.817-1.38-23.274-8.555-1.721-3.574-.576-6.421.988-9.385,5.143,3.741,14.45,6.292,20.692.656C901.1,745.392,894.658,744.322,889.558,742.436Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 8.275,
  cy: 8.275,
  r: 8.275,
  transform: "translate(871.319 712.089)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.753,
  cy: 5.753,
  r: 5.753,
  transform: "translate(873.841 714.611)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M906.84,727.961c5.36-9.787,6.664-18.547,2.557-21.993-5.285-4.433-17.68,1.486-28.688,13.327"
}), /*#__PURE__*/React.createElement("circle", {
  className: "c",
  cx: 4.646,
  cy: 4.646,
  r: 4.646,
  transform: "translate(900.679 725.964)"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.005,
    height: 58.789,
    viewBox: "0 0 81.005 58.789",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.0a6dffd9.svg";
export { ForwardRef as ReactComponent };